export default __webpack_public_path__ + "static/media/076.960da965.jpeg";